import { render } from "./modal.vue?vue&type=template&id=b6d54d54&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=b6d54d54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6d54d54"

export default script